import React, { Component } from 'react';
import CreateAccountForm from '../Account/create_form';
import { Row, Col } from 'react-bootstrap';
import '../stylesheets/SignUp.sass'

export default class AccountInfo extends Component {

  render () {
    let userId = this.props
      && this.props.location
      && this.props.location.state
      && this.props.location.state.userId

    return (
      <div>
        <div className={'sign-up-wrapper new-account-info'}>
          <div className={'row'}>
            <div className={'column'}>
            </div>
            <div className={'double-column'}>
              <div className={'create-account-title'}>
                Account Information
              </div>
            </div>
            <div className={'column'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'column'}>
            </div>
            <div className={'double-column'}>
              <div>
                This information is used to validate your account with our payment processing system.
              </div>
            </div>
            <div className={'column'}>
            </div>
          </div>
          <CreateAccountForm userId={ userId } create={true} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/SignUp/account_info.jsx